<template>
    <ion-page>
        <ion-header :translucent="true">
            <ion-toolbar>
                <ion-title color="white">Dettaglio evento</ion-title>
                <ion-buttons slot="start">
                    <ion-button @click="closeModal()">
                        <ion-icon slot="start" :icon="arrowBackOutline" color="white"></ion-icon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>

        <ion-content :fullscreen="true">
            <div class="page_content">

                <!-- Modale immagine ingrandita -->
                <Transition name="fade-transition">
                    <div v-show="showImgModal" class="attachment_modal">
                        <div class="customers_container">
                            <img :src="selectedImage" alt="Immagine evento" />
                        </div>
                        <div @click="closeAttachmentModal()" class="close_modal">Chiudi</div>
                    </div>
                </Transition>

                <div class="event">
                    <div v-if="event.events_title" class="event_title">
                        <div class="event_name">{{ event.events_title }}</div>
                    </div>

                    <div class="title">
                        <div class="event_date">{{ formatEventDate(event.events_date_start, event.events_date_end) }}</div>
                        <div class="event_time">
                            <div>{{ timeFormat(event.events_date_start) }} - {{ timeFormat(event.events_date_end) }}</div>
                        </div>
                    </div>

                    <div v-if="event.events_google_calendar" class="field_note">
                        <div class="title">Google calendar</div>
                        <div class="value">
                            {{ event.google_calendars_list_google_id }}
                        </div>
                    </div>

                    <div v-if="event.events_description" class="field_note">
                        <div class="title"></div>
                        <div class="value">
                            {{ event.events_description }}
                        </div>
                    </div>

                    <div v-if="event.events_image" class="field_note">
                        <div class="title"></div>
                        <div class="value">
                            <img :src="setImageUrl(event.events_image)" alt="" style="border-radius: 8px;">
                        </div>
                    </div>

                    <!-- Galleria immagini -->
                    <div v-if="event.events_gallery && event.events_gallery.length > 0" class="gallery-container">
                        <div class="gallery-scroll">
                            <div v-for="(img, idx) in JSON.parse(event.events_gallery)" :key="idx" class="gallery-thumb">
                                <img :src="galleryImageUrl(img)" :alt="img.original_filename || 'gallery'" @click="openImgDetail(img)" style="cursor:pointer;" />
                            </div>
                        </div>
                    </div>

                    <div class="field_note">
                        <div class="button_container_calendar">
                            <add-to-calendar-button
                                :name="event.events_title"
                                :description="event.events_description"
                                :location="event.events_address"
                                :startDate="formatDate(event.events_date_start)"
                                :endDate="formatDate(event.events_date_end)"
                                :startTime="formatTime(event.events_date_start)"
                                :endTime="formatTime(event.events_date_end)"
                                timeZone="Europe/Rome"
                                options="'Apple','Google'"
                                hideBranding
                                buttonsList
                                lightMode="bodyScheme"
                                styleLight="--btn-background: rgb(219 234 254); --btn-text: rgb(37 99 235); --btn-border: rgb(37 99 235); --btn-padding-x: 16px; --btn-padding-y: 8px;"
                            >
                            </add-to-calendar-button>
                        </div>
                    </div>

                    <div v-if="isPaidParticipationEvent" class="field_note container_pagamento">
                        <div v-if="paymentStatusLoading" class="payment_status_loading">Caricamento stato pagamento…</div>
                        <template v-else>
                            <div v-if="paymentPaid" class="payment_paid_notice">
                                <div class="payment_paid_title">Pagamento effettuato</div>
                                <div v-if="paymentPaidAmountLabel" class="payment_paid_amount">
                                    Importo versato: <strong>{{ paymentPaidAmountLabel }}&nbsp;€</strong>
                                </div>
                                <div v-if="paymentPaidAtLabel" class="payment_paid_date">
                                    Data: {{ paymentPaidAtLabel }}
                                </div>
                                <div v-if="!paymentPaidAmountLabel && !paymentPaidAtLabel" class="payment_paid_fallback">
                                    Il pagamento risulta registrato.
                                </div>
                            </div>
                            <template v-else>
                                <div v-if="paymentUnitFee > 0" class="payment_intro_text">
                                    <p class="payment_intro_paragraph">
                                        Questo evento prevede il pagamento di una
                                        <strong>quota a persona di {{ paymentUnitFeeLabel }}&nbsp;€</strong>.
                                    </p>
                                    <p v-if="paymentAdditionalCount > 0" class="payment_intro_paragraph">
                                        Considerando la tua partecipazione e
                                        <strong>{{ paymentAdditionalCount }}</strong>
                                        partecipante/i aggiuntivo/i, l'importo complessivo da versare è di
                                        <strong>{{ paymentTotalLabel }}&nbsp;€</strong>.
                                    </p>
                                    <p v-else class="payment_intro_paragraph">
                                        Per la tua iscrizione l'importo da versare è di
                                        <strong>{{ paymentTotalLabel }}&nbsp;€</strong>.
                                    </p>
                                </div>
                                <div
                                    class="btn_paga_evento"
                                    :class="{ disabled: paymentLoading || paymentUnitFee <= 0 }"
                                    @click="!paymentLoading && paymentUnitFee > 0 && openEventPayment()"
                                >
                                    {{ paymentLoading ? "Attendere…" : "Effettua pagamento" }}
                                </div>
                            </template>
                        </template>
                    </div>

                    <!-- Dati cliente collegato -->
                    <div v-if="event.events_customer_id" class="customer_data">
                        <div class="title">
                            {{ event.customers_full_name }}
                        </div>
                        <div class="field">
                            <div class="title">Telefono</div>
                            <div v-if="event.customers_mobile" class="value">
                                <a :href="`tel:${event.customers_mobile}`" target="_blank" class="mobile_link">{{ event.customers_mobile }}</a>
                            </div>
                            <div v-else>-</div>
                        </div>
                        <div class="field">
                            <div class="title">Email</div>
                            <div v-if="event.customers_email" class="value">
                                <a :href="`mailto:${event.customers_email}`" target="_blank" class="mobile_link">{{ event.customers_email }}</a>
                            </div>
                            <div v-else>-</div>
                        </div>
                        <div class="field_note field_note_address">
                            <div class="title">Indirizzo</div>
                            <div class="value">
                                <a
                                    :href="`https://maps.google.com/?q=${event.customers_city} ${event.customers_address} ${event.customers_zip_code}`"
                                    target="_blank"
                                    class="mobile_link mobile_link_maps"
                                >
                                    {{ formattedAddress() }}
                                </a>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="!event.events_customer_id && event.events_address" style="width:100%;">
                        <div class="field_note field_note_address">
                            <div class="title">Indirizzo</div>
                            <div class="value">
                                <a
                                    :href="`https://maps.google.com/?q=${event.events_address}`"
                                    target="_blank"
                                    class="mobile_link mobile_link_maps"
                                >
                                    {{ event.events_address }}
                                </a>
                            </div>
                        </div>
                    </div>


                    <div v-if="event.events_requires_confirmation && event.events_requires_confirmation == '1' && !confirmationSend" style="margin-top: 32px; width: 100%;">
                        <div style="text-align: center;">Parteciperai? Sì, ancora non lo so oppure no</div>

                        <div class="delete_button_container" style="display: flex; gap: 16px;">
                            <div class="button_container">
                                <button 
                                    @click="setConfirmation(1)"         
                                    :class="{ active: selectedConfirmation === 1 }"
                                    :style="{ opacity: selectedConfirmation && selectedConfirmation !== 1 ? 0.4 : 1 }"
                                    class="btn_partecipate confirm" 
                                    style="height: 40px;"
                                    >
                                    <font-awesome-icon :icon="['fas', 'thumbs-up']" style="color: rgb(37 99 235); font-size: 20px;" />
                                    <div class="answer_container" style="color: rgb(37 99 235); font-size: 20px;">{{ event.count_yes }}</div>
                                </button>
                            </div>

                            <div class="button_container">
                                <button 
                                    @click="setConfirmation(2)"         
                                    :class="{ active: selectedConfirmation === 2 }"
                                    :style="{ opacity: selectedConfirmation && selectedConfirmation !== 2 ? 0.4 : 1 }"
                                    class="btn_partecipate maybe" 
                                    style="height: 40px;"
                                    >
                                    <font-awesome-icon :icon="['fas', 'question']" style="color: rgb(234 88 12); font-size: 20px;" />
                                    <div class="answer_container" style="color: rgb(234 88 12); font-size: 20px;">{{ event.count_maybe }}</div>
                                </button>
                            </div>

                            <div class="button_container">
                                <button 
                                    @click="setConfirmation(3)"         
                                    :class="{ active: selectedConfirmation === 3 }"
                                    :style="{ opacity: selectedConfirmation && selectedConfirmation !== 3 ? 0.4 : 1 }"
                                    class="btn_partecipate not_confirm" 
                                    style="height: 40px;"
                                    >
                                    <font-awesome-icon :icon="['fas', 'thumbs-down']" style="color: rgb(220 38 38); font-size: 20px;" />
                                    <div class="answer_container" style="color: rgb(220 38 38); font-size: 20px;">{{ event.count_no }}</div>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div v-else-if="event.events_requires_confirmation && event.events_requires_confirmation == '1' && confirmationSend" style="margin-top: 32px; width: 100%;">
                        <div style="text-align: center;">Modifica la tua risposta</div>

                        <div class="delete_button_container" style="display: flex; gap: 16px;">
                            <div class="button_container">
                                <button 
                                    @click="setConfirmation(1)"         
                                    :class="{ active: selectedConfirmation === 1 }"
                                    :style="{ opacity: selectedConfirmation && selectedConfirmation !== 1 ? 0.4 : 1 }"
                                    class="btn_partecipate confirm" 
                                    style="height: 40px;"
                                    >
                                    <font-awesome-icon :icon="['fas', 'thumbs-up']" style="color: rgb(37 99 235); font-size: 20px;" />
                                    <div class="answer_container" style="color: rgb(37 99 235); font-size: 20px;">{{ event.count_yes }}</div>
                                </button>
                            </div>

                            <div class="button_container">
                                <button 
                                    @click="setConfirmation(2)"         
                                    :class="{ active: selectedConfirmation === 2 }"
                                    :style="{ opacity: selectedConfirmation && selectedConfirmation !== 2 ? 0.4 : 1 }"
                                    class="btn_partecipate maybe" 
                                    style="height: 40px;"
                                    >
                                    <font-awesome-icon :icon="['fas', 'question']" style="color: rgb(234 88 12); font-size: 20px;" />
                                    <div class="answer_container" style="color: rgb(234 88 12); font-size: 20px;">{{ event.count_maybe }}</div>
                                </button>
                            </div>

                            <div class="button_container">
                                <button 
                                    @click="setConfirmation(3)"         
                                    :class="{ active: selectedConfirmation === 3 }"
                                    :style="{ opacity: selectedConfirmation && selectedConfirmation !== 3 ? 0.4 : 1 }"
                                    class="btn_partecipate not_confirm" 
                                    style="height: 40px;"
                                    >
                                    <font-awesome-icon :icon="['fas', 'thumbs-down']" style="color: rgb(220 38 38); font-size: 20px;" />
                                    <div class="answer_container" style="color: rgb(220 38 38); font-size: 20px;">{{ event.count_no }}</div>

                                </button>
                            </div>
                            
                        </div>
                    </div>

                    <div v-if="showAdditionalControls" class="additional_participants">
                        <div class="additional_label">Numero di partecipanti aggiuntivi</div>
                        <div class="additional_controls">
                            <button 
                                class="additional_button"
                                @click="decrementAdditional"
                                :disabled="additionalParticipants <= 0 || additionalLoading"
                            >
                                -
                            </button>
                            <div class="additional_value">{{ additionalParticipants }}</div>
                            <button 
                                class="additional_button"
                                @click="incrementAdditional"
                                :disabled="additionalLoading"
                            >
                                +
                            </button>
                        </div>
                        <button 
                            class="btn_save_additional"
                            @click="saveAdditionalParticipants"
                            :disabled="additionalLoading"
                        >
                            <span v-if="!additionalLoading">Salva</span>
                            <span v-else>Salvataggio...</span>
                        </button>
                    </div>

                    <!-- <div class="delete_button_container">
                        <button @click="deleteEvent()" class="btn_delete_event">Elimina evento</button>
                    </div> -->
                </div>

                <!-- Elenco partecipanti -->
                <div v-if="event.partecipants && event.partecipants.length > 0" class="event event_list">
                    <div class="event_title">
                        <div class="event_name">Elenco partecipanti</div>
                    </div>

                    <div v-for="(partecipant, index) in event.partecipants" :key="participantRowKey(partecipant, index)" class="single_participant">
                        <span>{{ partecipant.users_first_name }} {{ partecipant.users_last_name }}</span>
                        <span
                            :style="{ color: getPartecipationColor(partecipant.events_participants_users_partecipate) }"
                            style="font-weight: 600;"
                        >
                            {{ partecipant.events_participants_users_partecipate_value }}
                            <span v-if="partecipant.events_participants_users_additional && parseInt(partecipant.events_participants_users_additional, 10) > 0">
                                +{{ partecipant.events_participants_users_additional }}
                            </span>
                        </span>
                    </div>
                </div>


            </div>
        </ion-content>
    </ion-page>
</template>

<script>
import {
    IonPage,
    IonHeader,
    IonToolbar,
    IonButtons,
    //IonBackButton,
    IonTitle,
    IonContent,
    IonIcon,
    IonButton,
    modalController,
    getPlatforms
} from "@ionic/vue";

import { defineComponent, ref, onMounted, computed, watch } from "vue";
import { alertController } from "@ionic/vue";

import { arrowBackOutline } from "ionicons/icons";

import moment from "moment";
import 'add-to-calendar-button';

import { LOCALSTORAGE_KEY } from "@/custom_config";


import { openToast } from "@/services/toast";
import { dateFormat, timeFormat } from "@/services/utils";

import apiCalendario from "@/services/calendario";
import apiEventi from "@/services/eventi";

export default defineComponent({
    name: "EvetDetail",
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    components: {
        IonPage,
        IonHeader,
        IonToolbar,
        IonButtons,
        //IonBackButton,
        IonTitle,
        IonContent,
        IonIcon,
        IonButton,
    },
    setup(props, context) {
        // console.log(props.data);
        const userID = JSON.parse(localStorage.getItem(`${LOCALSTORAGE_KEY}`)).dipendenti_user_id;
        const userData = JSON.parse(localStorage.getItem(`${LOCALSTORAGE_KEY}`));

        const event = ref([]);
        event.value = { ...props.data };
        if (!Array.isArray(event.value.partecipants)) {
            event.value.partecipants = [];
        }
        //console.log(event.value);


        const isAndroid = ref(false);
        const isIos = ref(false);
        const platforms = getPlatforms();
        if (platforms.includes("android")) {
            isAndroid.value = true;
        } else if (platforms.includes("ios") || platforms.includes("iphone")) {
            isIos.value = true;
        }


        function setImageUrl(path) {
            if (path && path != '') {
                return `${process.env.VUE_APP_BASE_URL}/uploads/${path}`;
            }
        }

        // Helper per immagini della galleria
        function galleryImageUrl(img) {
            // console.log(img);
            if (img && img.path_local) {
                return `${process.env.VUE_APP_BASE_URL}/uploads/${img.path_local}`;
            }
            return '';
        }

        /**
         * Handle close modal by clicking on Chiudi button
         */
        const closeModal = (deleted = false) => {
            modalController.dismiss(deleted);
        };

        const formatEventDate = (startDate, endDate) => {
            const start = new Date(startDate);
            const end = new Date(endDate);

            if (start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth() && start.getDate() === end.getDate()) {
                return dateFormat(startDate);
            } else {
                return `${dateFormat(startDate)} - ${dateFormat(endDate)}`;
            }
        };

        const formattedAddress = () => {
            const { customers_address, customers_city, customers_province } = event.value;

            let formatted = "";

            if (customers_address && customers_address.trim() !== "") {
                formatted += customers_address + ", ";
            }
            if (customers_city && customers_city.trim() !== "") {
                formatted += customers_city + " (";
            }
            if (customers_province && customers_province.trim() !== "") {
                formatted += customers_province + ")";
            }

            return formatted;
        };

        async function handleCancellation() {
            if (event.value.events_id) {
                let deleted = false;

                const res = await apiCalendario.deleteEvent(event.value.events_id);

                if (res.status === 200 && Number(res.data?.status) === 0) {
                    deleted = true;
                    closeModal(deleted);
                } else {
                    openToast("Si è verificato un durante l'eliminazione dell'evento", "toast_danger");
                    closeModal(deleted);
                }
            } else {
                openToast("Non è stato possibile riconscere l'evento da eliminare", "toast_danger");
            }
        }

        async function showAlert() {
            const alert = await alertController.create({
                header: "Elimina evento",
                message: "Vuoi eliminare definitivamente questo evento?",
                backdropDismiss: false,
                buttons: [
                    {
                        text: "Annulla",
                        handler: () => {
                            // Close alert
                        },
                    },
                    {
                        text: "Elimina",
                        handler: () => {
                            handleCancellation();
                        },
                    },
                ],
            });
            return alert.present();
        }

        async function deleteEvent() {
            await showAlert();
        }


        const confirmationSend = ref(false);
        const selectedConfirmation = ref(null);
        const currentRelationId = ref(null);
        const additionalParticipants = ref(0);
        const additionalLoading = ref(false);
        const showAdditionalControls = computed(() => selectedConfirmation.value === 1 && !!currentRelationId.value);

        function incrementAdditional() {
            additionalParticipants.value += 1;
        }

        function decrementAdditional() {
            if (additionalParticipants.value > 0) {
                additionalParticipants.value -= 1;
            }
        }

        function normalizeRelationId(value) {
            if (!value) {
                return null;
            }

            if (typeof value === "object") {
                if (value.id) {
                    return value.id.toString();
                }
                if (value.relation_id) {
                    return value.relation_id.toString();
                }
                if (value.events_participants_users_id) {
                    return value.events_participants_users_id.toString();
                }
            }

            return value.toString();
        }

        function sameUserId(a, b) {
            if (a === undefined || a === null || b === undefined || b === null) {
                return false;
            }
            return String(a) === String(b);
        }

        function participantRowKey(partecipant, index) {
            const uid = partecipant?.users_id;
            const pid = partecipant?.events_participants_users_id;
            const st = partecipant?.events_participants_users_partecipate ?? partecipant?.events_participants_users_partecipate_id;
            if (uid !== undefined && uid !== null) {
                return `u${uid}-${pid ?? "np"}-${st ?? ""}`;
            }
            return `i${index}`;
        }

        function normalizeAdditionalCount(value, fallback = 0) {
            const parsed = parseInt(value, 10);
            return Number.isNaN(parsed) || parsed < 0 ? fallback : parsed;
        }

        function getAdditionalCount(participant) {
            if (!participant) {
                return 0;
            }
            return normalizeAdditionalCount(participant.events_participants_users_additional, 0);
        }

        function getAttendeesTotalFromCount(additional) {
            return 1 + normalizeAdditionalCount(additional, 0);
        }

        function getParticipantTotalAttendees(participant) {
            return getAttendeesTotalFromCount(getAdditionalCount(participant));
        }

        function updateCountersDelta(statusValue, delta) {
            if (!statusValue || delta === 0) {
                return;
            }

            const status = parseInt(String(statusValue), 10);
            if (Number.isNaN(status) || status < 1 || status > 3) {
                return;
            }

            const yes = Number(event.value.count_yes ?? 0) || 0;
            const maybe = Number(event.value.count_maybe ?? 0) || 0;
            const no = Number(event.value.count_no ?? 0) || 0;

            if (status === 1) {
                event.value.count_yes = Math.max(0, yes + delta);
            } else if (status === 2) {
                event.value.count_maybe = Math.max(0, maybe + delta);
            } else if (status === 3) {
                event.value.count_no = Math.max(0, no + delta);
            }
        }

        function resolveAdditionalCount(responseAdditional, fallbackParticipant, fallbackValue = 0) {
            if (responseAdditional !== null && typeof responseAdditional !== "undefined") {
                return normalizeAdditionalCount(responseAdditional, fallbackValue);
            }

            if (fallbackParticipant) {
                return getAdditionalCount(fallbackParticipant);
            }

            return normalizeAdditionalCount(fallbackValue, 0);
        }

        async function saveAdditionalParticipants() {
            if (!currentRelationId.value) {
                openToast("Non è stato possibile identificare la partecipazione", "toast_danger");
                return;
            }

            additionalLoading.value = true;
            
            // Converti relation_id in stringa (dovrebbe già essere una stringa)
            const relationIdString = normalizeRelationId(currentRelationId.value);
            if (!relationIdString) {
                openToast("Non è stato possibile identificare la partecipazione", "toast_danger");
                additionalLoading.value = false;
                return;
            }

            try {
                const res = await apiCalendario.addParticipants(relationIdString, additionalParticipants.value);

                if (res.status === 200 && Number(res.data?.status) === 0) {
                    openToast(res.data.txt, "toast_success");

                    const participant = Array.isArray(event.value.partecipants)
                        ? event.value.partecipants.find((p) => sameUserId(p.users_id, userID))
                        : null;

                    if (participant) {
                        const oldWeight = getParticipantTotalAttendees(participant);
                        const newAdditional = resolveAdditionalCount(
                            res.data ? res.data.additional : null,
                            null,
                            additionalParticipants.value
                        );
                        const newWeight = getAttendeesTotalFromCount(newAdditional);

                        participant.events_participants_users_additional = newAdditional.toString();
                        updateCountersDelta(
                            participant.events_participants_users_partecipate_id || participant.events_participants_users_partecipate,
                            newWeight - oldWeight
                        );

                        additionalParticipants.value = Math.max(0, newAdditional);
                    }
                    void refreshPaymentStatusFromServer();
                } else {
                    openToast(res.data.txt, "toast_danger");
                }
            } catch (error) {
                openToast("Si è verificato un errore durante il salvataggio dei partecipanti aggiuntivi", "toast_danger");
            } finally {
                additionalLoading.value = false;
            }
        }

        async function setConfirmation(status) {
            try {
                const res = await apiCalendario.setConfirmation(event.value.events_id, userID, status);
                const ok = res.status === 200 && Number(res.data?.status) === 0;

                if (ok) {
                    openToast(res.data.txt, "toast_success");
                    confirmationSend.value = true;

                    if (!Array.isArray(event.value.partecipants)) {
                        event.value.partecipants = [];
                    }

                    const participantsList = event.value.partecipants;
                    const existingParticipant = participantsList.find((p) => sameUserId(p.users_id, userID));

                    const relationId =
                        res.data && res.data.relation_id !== undefined && res.data.relation_id !== null
                            ? normalizeRelationId(res.data.relation_id)
                            : null;
                    const responseAdditional = resolveAdditionalCount(
                        res.data ? res.data.additional : null,
                        existingParticipant
                    );

                    let targetParticipant = existingParticipant;
                    let previousStatus = null;
                    let previousWeight = 0;

                    if (existingParticipant) {
                        previousStatus = existingParticipant.events_participants_users_partecipate_id || existingParticipant.events_participants_users_partecipate;
                        previousWeight = getParticipantTotalAttendees(existingParticipant);
                    }

                    if (!targetParticipant) {
                        targetParticipant = {
                            events_id: event.value.events_id,
                            users_id: userID,
                            users_first_name: userData.dipendenti_nome,
                            users_last_name: userData.dipendenti_cognome,
                            users_email: userData.dipendenti_email,
                            events_participants_users_additional: responseAdditional.toString()
                        };
                        participantsList.unshift(targetParticipant);
                        event.value.partecipants_count = participantsList.length;
                    }

                    targetParticipant.events_participants_users_partecipate = status.toString();
                    targetParticipant.events_participants_users_partecipate_id = status.toString();
                    targetParticipant.events_participants_users_partecipate_value =
                        status === 1 ? "Si" : status === 2 ? "Forse" : "No";
                    targetParticipant.events_participants_users_additional = responseAdditional.toString();

                    if (relationId) {
                        targetParticipant.events_participants_users_id = relationId;
                    }

                    updateCountersDelta(previousStatus, -previousWeight);
                    updateCountersDelta(status, getAttendeesTotalFromCount(responseAdditional));

                    selectedConfirmation.value = status;
                    
                    // Salva relation_id per permettere modifiche successive (es. partecipanti aggiuntivi)
                    // Il relation_id viene dalla risposta del backend e viene già assegnato al participant sopra
                    let nextRelationId = relationId;
                    if (!nextRelationId) {
                        if (existingParticipant && existingParticipant.events_participants_users_id) {
                            nextRelationId = normalizeRelationId(existingParticipant.events_participants_users_id);
                        } else {
                            const participant = participantsList.find((p) => sameUserId(p.users_id, userID));
                            if (participant && participant.events_participants_users_id) {
                                nextRelationId = normalizeRelationId(participant.events_participants_users_id);
                            }
                        }
                    }

                    currentRelationId.value = nextRelationId;

                    const normalizedAdditional = Math.max(0, responseAdditional);

                    if (status === 1) {
                        additionalParticipants.value = Math.max(0, normalizedAdditional);
                    } else {
                        additionalParticipants.value = 0;
                    }

                    event.value.partecipants = [...participantsList];
                    void refreshPaymentStatusFromServer();
                } else {
                    openToast(res.data?.txt || "Si è verificato un errore durante il salvataggio della risposta", "toast_danger");
                }
            } catch (error) {
                openToast("Si è verificato un errore durante il salvataggio della risposta", "toast_danger");
            }
        }


        function checkConfirmation() {
            const participantsList = Array.isArray(event.value.partecipants) ? event.value.partecipants : [];
            const existingParticipant = participantsList.find((p) => sameUserId(p.users_id, userID));

            if (existingParticipant) {
                confirmationSend.value = true;
                const participantStatus = parseInt(existingParticipant.events_participants_users_partecipate, 10);
                selectedConfirmation.value = isNaN(participantStatus) ? null : participantStatus;

                // Salva relation_id per permettere modifiche successive (es. partecipanti aggiuntivi)
                currentRelationId.value = existingParticipant.events_participants_users_id 
                    ? normalizeRelationId(existingParticipant.events_participants_users_id) 
                    : null;

                const participantAdditional = getAdditionalCount(existingParticipant);
                additionalParticipants.value = Math.max(0, participantAdditional);
            } else {
                confirmationSend.value = false;
                selectedConfirmation.value = null;
                currentRelationId.value = null;
                additionalParticipants.value = 0;
            }
        }


        function getPartecipationColor(value) {
            const colors = {
                1: "rgb(37 99 235)",  // Sì
                2: "rgb(234 88 12)",  // Forse
                3: "rgb(220 38 38)"   // No
            };
            return colors[value] || "inherit"; // Default se non corrisponde
        }


        // Calendar helpers
        const formatDate = (datetime) => {
            return moment(datetime).format("YYYY-MM-DD");
        };

        const formatTime = (datetime) => {
            return moment(datetime).format("HH:mm");
        };

        const showImgModal = ref(false);
        const selectedImage = ref(null);

        function openImgDetail(img) {
            showImgModal.value = true;
            selectedImage.value = galleryImageUrl(img);
        }

        function closeAttachmentModal() {
            showImgModal.value = false;
        }

        /** Support table partecipazione: 1 = senza pagamento, 2 = a pagamento (CRM / events). */
        const PAID_PARTICIPATION_TYPE_ID = 2;
        const isPaidParticipationEvent = computed(() => {
            const ev = event.value;
            if (!ev || typeof ev !== "object") {
                return false;
            }
            const raw = ev.events_participation_payment_type ?? ev.events_calendar_participation_payment_type;
            return parseInt(String(raw ?? "0"), 10) === PAID_PARTICIPATION_TYPE_ID;
        });

        const paymentPaid = ref(false);
        const paymentPaidAt = ref(null);
        const paymentPaidAmount = ref(null);
        const paymentLoading = ref(false);
        const paymentStatusLoading = ref(false);

        function dateTimeFormatPaid(dateTime) {
            if (dateTime && moment(dateTime).isValid()) {
                return moment(dateTime).format("DD/MM/YYYY HH:mm");
            }
            return "";
        }

        const paymentPaidAtLabel = computed(() => {
            if (!paymentPaidAt.value) {
                return "";
            }
            return dateTimeFormatPaid(paymentPaidAt.value);
        });

        const paymentPaidAmountLabel = computed(() => {
            const v = paymentPaidAmount.value;
            if (v === null || v === undefined || !Number.isFinite(Number(v))) {
                return "";
            }
            return formatEuroAmount(Number(v));
        });

        function formatEuroAmount(value) {
            const n = Number(value);
            if (!Number.isFinite(n)) {
                return "0,00";
            }
            return n.toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }

        const paymentUnitFee = computed(() => {
            const ev = event.value;
            const raw = ev?.events_participation_fee_amount ?? ev?.events_participation_fee ?? 0;
            const n = parseFloat(String(raw).replace(",", "."));
            return Number.isFinite(n) && n > 0 ? n : 0;
        });

        const paymentAdditionalCount = computed(() => {
            const n = parseInt(String(additionalParticipants.value ?? 0), 10);
            return Number.isNaN(n) || n < 0 ? 0 : n;
        });

        const paymentHeadcount = computed(() => 1 + paymentAdditionalCount.value);

        const paymentTotalAmount = computed(() => {
            const tot = paymentUnitFee.value * paymentHeadcount.value;
            return Math.round(tot * 100) / 100;
        });

        const paymentUnitFeeLabel = computed(() => formatEuroAmount(paymentUnitFee.value));
        const paymentTotalLabel = computed(() => formatEuroAmount(paymentTotalAmount.value));

        /**
         * Apre il link di pagamento.
         *
         * Su WebKit mobile (Safari iOS, PWA Ionic) navigare una finestra aperta con
         * `window.open('about:blank')` **dopo** una `await` (chiamata API) viene spesso
         * ignorato: la scheda resta su `about:blank` senza errori in console.
         * Per questo su iOS/Android non usiamo la popup: stessa finestra (`location.assign`).
         *
         * Su desktop si può usare la popup aperta in modo sincrono sul tap "Sì".
         *
         * @param {string} url
         * @param {Window | null} blankWindow finestra aperta sul tap "Sì", o null (mobile / popup bloccata)
         */
        function openPaymentLink(url, blankWindow) {
            const usePopup = blankWindow && typeof blankWindow === "object" && !blankWindow.closed;
            if (usePopup) {
                try {
                    blankWindow.opener = null;
                    blankWindow.location.replace(url);
                } catch (e) {
                    try {
                        blankWindow.close();
                    } catch (e2) {
                        /* ignore */
                    }
                    window.location.assign(url);
                }
                return;
            }
            window.location.assign(url);
        }

        async function executeEventPayment(blankWindow) {
            if (!isPaidParticipationEvent.value || paymentLoading.value || !event.value.events_id) {
                if (blankWindow && !blankWindow.closed) {
                    try {
                        blankWindow.close();
                    } catch (e) {
                        /* ignore */
                    }
                }
                return;
            }
            paymentLoading.value = true;
            try {
                const res = await apiEventi.createEventPaymentLink(
                    String(event.value.events_id),
                    String(userID),
                    undefined,
                    paymentAdditionalCount.value,
                    true,
                );
                if (res.data.status !== 0) {
                    if (blankWindow && !blankWindow.closed) {
                        try {
                            blankWindow.close();
                        } catch (e) {
                            /* ignore */
                        }
                    }
                    openToast(res.data.txt || "Impossibile avviare il pagamento", "toast_danger");
                    return;
                }
                const d = res.data.data || {};
                if (d.already_paid) {
                    if (blankWindow && !blankWindow.closed) {
                        try {
                            blankWindow.close();
                        } catch (e) {
                            /* ignore */
                        }
                    }
                    paymentPaid.value = true;
                    paymentPaidAt.value = d.paid_at || null;
                    if (d.paid_amount !== undefined && d.paid_amount !== null && Number.isFinite(Number(d.paid_amount))) {
                        paymentPaidAmount.value = Number(d.paid_amount);
                    }
                    openToast(res.data.txt || "Pagamento già registrato", "toast_success");
                    return;
                }
                if (d.payment_link) {
                    openPaymentLink(d.payment_link, blankWindow);
                } else {
                    if (blankWindow && !blankWindow.closed) {
                        try {
                            blankWindow.close();
                        } catch (e) {
                            /* ignore */
                        }
                    }
                    openToast("Link di pagamento non disponibile", "toast_danger");
                }
            } catch (e) {
                console.error(e);
                if (blankWindow && !blankWindow.closed) {
                    try {
                        blankWindow.close();
                    } catch (e2) {
                        /* ignore */
                    }
                }
                openToast("Errore durante la richiesta di pagamento", "toast_danger");
            } finally {
                paymentLoading.value = false;
            }
        }

        async function openEventPayment() {
            if (!isPaidParticipationEvent.value || paymentLoading.value || !event.value.events_id) {
                return;
            }
            if (paymentUnitFee.value <= 0 || paymentTotalAmount.value <= 0) {
                openToast("Importo della quota non disponibile per questo evento.", "toast_danger");
                return;
            }

            const totalStr = paymentTotalLabel.value;
            const addN = paymentAdditionalCount.value;
            const headN = paymentHeadcount.value;
            const message =
                addN > 0
                    ? `Se continui, verrai indirizzato al portale di pagamento per versare ${totalStr} € totali per ${headN} partecipante/i.`
                    : `Se continui, verrai indirizzato al portale di pagamento per versare ${totalStr} €.`;

            const alert = await alertController.create({
                header: "Conferma pagamento",
                message,
                backdropDismiss: false,
                buttons: [
                    {
                        text: "No",
                        role: "cancel",
                    },
                    {
                        text: "Sì",
                        handler: () => {
                            // iOS/Android: niente popup + about:blank — dopo l'await la navigazione
                            // della seconda finestra non è affidabile (pagina bianca).
                            if (isIos.value || isAndroid.value) {
                                void executeEventPayment(null);
                                return;
                            }
                            const blank = window.open("about:blank", "_blank", "noopener,noreferrer");
                            void executeEventPayment(blank);
                        },
                    },
                ],
            });
            await alert.present();
        }

        async function refreshPaymentStatusFromServer() {
            if (!isPaidParticipationEvent.value || !event.value?.events_id) {
                paymentStatusLoading.value = false;
                return;
            }
            paymentStatusLoading.value = true;
            try {
                const res = await apiEventi.getEventPaymentStatus(String(event.value.events_id), String(userID));
                if (res.status === 200 && Number(res.data?.status) === 0 && res.data.data) {
                    const d = res.data.data;
                    if (d.paid === true) {
                        paymentPaid.value = true;
                        paymentPaidAt.value = d.paid_at || null;
                        if (d.paid_amount !== undefined && d.paid_amount !== null && Number.isFinite(Number(d.paid_amount))) {
                            paymentPaidAmount.value = Number(d.paid_amount);
                        } else {
                            paymentPaidAmount.value = null;
                        }
                    } else {
                        paymentPaid.value = false;
                        paymentPaidAt.value = null;
                        paymentPaidAmount.value = null;
                    }
                }
            } catch (e) {
                console.error(e);
            } finally {
                paymentStatusLoading.value = false;
            }
        }

        watch(
            () => event.value?.events_id,
            (id, prev) => {
                if (id && id !== prev) {
                    paymentPaid.value = false;
                    paymentPaidAt.value = null;
                    paymentPaidAmount.value = null;
                }
                void refreshPaymentStatusFromServer();
            },
        );

        onMounted(() => {
            if (isPaidParticipationEvent.value && event.value?.events_id) {
                paymentStatusLoading.value = true;
            }
            checkConfirmation();
            void refreshPaymentStatusFromServer();
        });

        return {
            event,
            setImageUrl,
            galleryImageUrl,
            dateFormat,
            timeFormat,
            arrowBackOutline,
            closeModal,
            deleteEvent,
            formatEventDate,
            formattedAddress,
            // Partecipazione ed elenco partecipanti
            setConfirmation,
            confirmationSend,
            selectedConfirmation,
            getPartecipationColor,
            participantRowKey,
            currentRelationId,
            additionalParticipants,
            additionalLoading,
            incrementAdditional,
            decrementAdditional,
            saveAdditionalParticipants,
            showAdditionalControls,
            // Calendar helpers
            formatDate,
            formatTime,
            // Modal immagine
            showImgModal,
            selectedImage,
            openImgDetail,
            closeAttachmentModal,
            // Pagamento evento
            isPaidParticipationEvent,
            paymentPaid,
            paymentPaidAtLabel,
            paymentPaidAmountLabel,
            paymentStatusLoading,
            paymentLoading,
            paymentUnitFee,
            paymentUnitFeeLabel,
            paymentTotalLabel,
            paymentAdditionalCount,
            openEventPayment,
        };
    },
});
</script>

<style scoped>
ion-toolbar {
    --background: #086fa3;
    --color: #ffffff;
}
.loading_spinner {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

ion-item {
    font-size: 14px;
}
ion-label {
    margin: 0;
}

.description_title {
    color: var(--ion-color-primary, #3880ff) !important;
    margin: 10px 0;
}

/* New rules */
.page_content {
    width: 100%;
    position: relative; /* to be used for new event btn */
    padding: 16px;
    min-height: 100%;
    background: #f2f2f2;
}

.event {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    padding: 16px;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 2px 3px 0px rgba(58, 58, 58, 0.1);
}
.event_customer {
    margin-top: 24px;
}
.event > .event_title,
.event .customer_data > .title {
    width: 100%;
    padding: 8px;
    color: #121212;
    text-align: center;
}
.event > .title {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 8px;
}
.event .event_title .event_name {
    font-size: 20px;
    font-weight: 500;
}
.event .title .event_date {
    width: 100%;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
}
.event .title .event_time {
    width: 100%;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
}

.event .customer_data {
    width: 100%;
    margin-top: 24px;
    border-top: 0.5px solid #7676803d;
}
.event .field {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /*padding: 12px 6px;*/
    padding: 12px 0px;
    /*margin-bottom: 10px;*/
    border-bottom: 1px solid #e2e8f0;
}
.event .customer_data .field {
    border-bottom: none;
}
.event .field_note {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    padding: 12px 0px;
    border-bottom: none;
}
.event .field_ricevuta {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    padding: 12px 6px;
}
.field .title,
.field_note .title,
.field_ricevuta .title {
    font-size: 14px;
    font-weight: 500;
    color: #121212;
}
.field_ricevuta .title {
    margin-bottom: 8px;
}
.field_note .title {
    margin-bottom: 8px;
}
.field .value,
.field_note .value,
.field_ricevuta .value {
    font-size: 14px;
}

.value .badge {
    font-size: 12px;
    font-weight: bold;
    color: #ffffff;
    padding: 4px 8px;
    border-radius: 4px;
}

.value .badge.badge_inserita {
    background-color: rgb(254 243 199);
    color: rgb(245 158 11);
}
.value .badge.badge_rimborsata {
    background-color: rgb(220 252 231);
    color: rgb(34 197 94);
}
.value .badge.badge_rifiutata {
    background-color: rgb(254 226 226);
    color: rgb(239 68 68);
}
.value .badge.badge_accettata {
    background-color: rgb(219 234 254);
    color: rgb(59 130 246);
}
ion-button {
    --color: #ffffff;
}

.delete_button_container {
    width: 100%;
    margin-top: 24px;
}

.btn_delete_event {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 10px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 12px;
    color: rgb(220 38 38);
    background-color: rgb(254 226 226);
}

.btn_partecipate {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 10px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 12px;
    background-color: rgb(219 234 254);
    color: rgb(37 99 235);
}
.btn_partecipate.confirm {
    background-color: rgb(219 234 254);
    color: rgb(37 99 235);
    margin-bottom: 12px;
}
.btn_partecipate.maybe {
    color: rgb(234 88 12);
    background-color: rgb(255 237 213);
    margin-bottom: 12px;
}
.btn_partecipate.not_confirm {
    color: rgb(220 38 38);
    background-color: rgb(254 226 226);
}

.mobile_link {
    color: #086fa3;
    text-decoration: none;
}
.mobile_link_maps {
    width: 100%;
    display: block;
    text-align: right;
}

.event_list {
    margin-top: 24px;
}

.event_list .single_participant {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
    font-size: 14px;
}

.button_container {
    width: 100%;
}

.button_container_calendar {
    width: 100%;
    display: flex;
    justify-content: center;
}

#atcb-reference {
    display: none;
}

add-to-calendar-button#css-part-example::part(atcb-button),
  #atcb-btn-css-part-example-modal-host::part(atcb-button) {
    background-color: #264f3c;
    color: #fff;
  }
  /* or, for all buttons and modals:
  .add-to-calendar::part(atcb-button) {
    background-color: #264f3c;
    color: #fff;
  }
  */

.gallery-container {
    width: 100%;
    margin: 12px 0 0 0;
    padding-bottom: 8px;
}
.gallery-scroll {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    gap: 12px;
    padding-bottom: 4px;
}
.gallery-thumb {
    flex: 0 0 auto;
    width: 80px;
    height: 80px;
    border-radius: 8px;
    overflow: hidden;
    background: #f2f2f2;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}
.gallery-thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
}

/* Modale immagine ingrandita */
.attachment_modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.7);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}
.customers_container {
    max-width: 90vw;
    max-height: 80vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
.attachment_modal img {
    max-width: 100%;
    max-height: 80vh;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.2);
}
.close_modal {
    margin-top: 24px;
    color: #fff;
    background: #086fa3;
    padding: 8px 24px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    transition: background 0.2s;
}
.close_modal:hover {
    background: #05507a;
}
/* Fade transition */
.fade-transition-enter-active, .fade-transition-leave-active {
    transition: opacity 0.2s;
}
.fade-transition-enter-from, .fade-transition-leave-to {
    opacity: 0;
}

.additional_participants {
    width: 100%;
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
}

.additional_label {
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    color: #121212;
}

.additional_controls {
    display: flex;
    align-items: center;
    gap: 12px;
}

.additional_button {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: none;
    background-color: rgb(219 234 254);
    color: rgb(37 99 235);
    font-size: 20px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.additional_button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.additional_value {
    min-width: 40px;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    color: #121212;
}

.btn_save_additional {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 12px;
    border: none;
    cursor: pointer;
    background-color: rgb(37 99 235);
    color: #ffffff;
}

.btn_save_additional:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.container_pagamento {
    width: 100%;
    margin-top: 8px;
}
.payment_status_loading {
    font-size: 14px;
    color: #64748b;
    padding: 10px 0;
    text-align: center;
}
.payment_paid_title {
    font-weight: 600;
    margin-bottom: 8px;
}
.payment_paid_amount,
.payment_paid_date {
    font-size: 14px;
    margin-top: 4px;
    color: #166534;
}
.payment_paid_fallback {
    font-size: 14px;
    margin-top: 4px;
}
.payment_intro_text {
    margin-bottom: 16px;
    padding: 12px 14px;
    background: #f8fafc;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
}
.payment_intro_paragraph {
    margin: 0 0 10px 0;
    font-size: 14px;
    line-height: 1.5;
    color: #334155;
    text-align: left;
}
.payment_intro_paragraph:last-child {
    margin-bottom: 0;
}
.payment_paid_notice {
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: #15803d;
    padding: 12px;
    background: #f0fdf4;
    border-radius: 8px;
    border: 1px solid #bbf7d0;
}
.btn_paga_evento {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 12px 24px;
    color: #ffffff;
    background-color: #086fa3;
    font-weight: 500;
    border-radius: 8px;
    text-transform: uppercase;
    cursor: pointer;
    box-sizing: border-box;
}
.btn_paga_evento.disabled {
    opacity: 0.65;
    pointer-events: none;
}
</style>
